import React from 'react';
import { useScreenSize } from '../../utils/media-query';
import RadioGroup from 'devextreme-react/radio-group';
import './style.scss';

export const priorities = ['Low', 'Normal', 'Urgent', 'High'];
export const priorityEntities = [
  { id: 0, text: 'Low' },
  { id: 1, text: 'Normal' },
  { id: 2, text: 'Urgent' },
  { id: 3, text: 'High' },
];
export const tasks = [{
  id: 0,
  subject: 'Choose between PPO and HMO Health Plan',
  priority: 3,
}, {
  id: 1,
  subject: 'Non-Compete Agreements',
  priority: 0,
}, {
  id: 2,
  subject: 'Comment on Revenue Projections',
  priority: 1,
}, {
  id: 3,
  subject: 'Sign Updated NDA',
  priority: 2,
}, {
  id: 4,
  subject: 'Submit Questions Regarding New NDA',
  priority: 3,
}, {
  id: 5,
  subject: 'Rollout of New Website and Marketing Brochures',
  priority: 3,
}];

export default function Radios() {
  const { isXSmall } = useScreenSize();
  const [colorPriority, setColorPriority] = React.useState(priorities[2]);
  const renderCustomItem = (data) => {
    return <div>{data}</div>;
  }
  const changeColorPriority = (e) => {
    setColorPriority(e.value);
  }
  return (
    <React.Fragment>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Default mode</div>
            <div className="form-value">
              <RadioGroup items={priorities} defaultValue={priorities[0]} />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Horizontal layout</div>
            <div className="form-value">
              <RadioGroup items={priorities} defaultValue={priorities[0]} layout={!isXSmall ? "horizontal" : "vertical"} />
            </div>
          </div>
        </div>
        <div className="form-col">  
          <div className="form-group">
            <div className="form-label">Disabled</div>
            <div className="form-value">
              <RadioGroup items={priorities} defaultValue={priorities[1]} disabled={true} />
            </div>
          </div>
        </div>
        <div className="form-col">  
          <div className="form-group">
            <div className="form-label">Custom item template</div>
            <div className="form-value">
              <RadioGroup
                className={colorPriority.toLowerCase()}
                items={priorities} 
                value={colorPriority}
                itemRender={renderCustomItem}
                onValueChanged={changeColorPriority}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
)}
